/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2026 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import React from 'react'
import RegularTemplate from '@/components/templates/RegularTemplate'
import DefaultCrudTable from '@/components/tables/DefaultCrudTable'
import { useFetchItemsWithParamsV2 } from '@/hooks/fetch/useFetchItemsWithParamsV2'
import { getAssetsLicensesBatches } from '@/services/assets-licenses-batches'
import { columns } from './handlers'
import CustomTableBody from './components/CustomTableBody'
import { Link } from 'react-router-dom'
import { assetLicenseBatchesUrls } from '@/configs/urls'
import { Button } from '@chakra-ui/react'
import {
  LICENSE_ASSETS_TITLE,
  CREATE_ASSET_LICENSING_BATCH,
  LICENSE_MULTIPLE_LISTED_ASSETS_COUNT
} from '@/configs/strings/asset-licenses-batches.strings'
import MainTotalItems from '@/components/listings/MainTotalItems'
import SimpleFilterBatchList from '@/components/listings/SimpleFilterBatchList'

const AssetLicensesBatchesList = () => {
  const { base, create } = assetLicenseBatchesUrls
  const urlCreate = `/${base}/${create}`
  const {
    itemsResponse,
    loading,
    onChangePage,
    page,
    searchParams,
    setSearchParams,
    totalPages
  } = useFetchItemsWithParamsV2({
    fetchService: getAssetsLicensesBatches
  })

  return (
  <RegularTemplate
    title={LICENSE_ASSETS_TITLE}
    loadingContent={loading && !itemsResponse}
  >
    <section className="mb-5">
      <Button
        as={Link}
        to={urlCreate}
      >
        { CREATE_ASSET_LICENSING_BATCH }
      </Button>
    </section>
    <SimpleFilterBatchList
      className="mb-3"
      onFilterResults={(filter) => setSearchParams(filter)}
      onReset={() => setSearchParams({})}
      searchParams={searchParams}
    />
    <MainTotalItems
      label={LICENSE_MULTIPLE_LISTED_ASSETS_COUNT}
      total={itemsResponse?.total}
      className="mb-3"
    />
    <DefaultCrudTable
      page={page}
      loading={loading}
      totalPages={totalPages}
      onPageChange={(page) => onChangePage(page)}
    >
      <DefaultCrudTable.Header
        columns={columns}
      />
      <CustomTableBody
        columns={columns}
        items={itemsResponse?.data}
      />
    </DefaultCrudTable>
  </RegularTemplate>
  )
}

export default AssetLicensesBatchesList
